
const getEnv = () => {
  const iURL = window.location.href;
  const url_dev = "http://localhost";
  const url_prd = "https://losolivosbogota.com";
  if (iURL.includes("127.0.0.1") || iURL.includes("localhost:3000")) {
    return { url: url_dev, envel: "dev" };
  } else {
    return { url: url_prd, envel: "prd" };
  }
};


module.exports = {
  getEnv,
};
